import { Link, NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import { useFonts } from "expo-font";
import { useState } from 'react';
import { Linking, Pressable, StyleSheet, Text, View, useWindowDimensions } from 'react-native';
import 'react-native-gesture-handler';
import Feather from 'react-native-vector-icons/Feather';
import { ErrorBoundary } from "./ErrorBoundary";
import { HelpModal } from "./HelpModal";
import { Invoice } from './Invoice';

const Stack = createStackNavigator()

function Selectable({ onPress, text, external }) {
  const [hovered, setHovered] = useState(false)

  return (
    <Pressable
      onPress={onPress}
      onHoverIn={() => setHovered(true)}
      onHoverOut={() => setHovered(false)}
      style={({ pressed }) => (pressed ? { opacity: 0.8 } : undefined)}
    >
      <View style={[styles.pill, hovered && styles.pillHovered]}>
        <Text style={styles.pillText}>{text}</Text>
        {external ? <Feather name="arrow-up-right" size={12} color="#8a90a0" /> : null}
      </View>
    </Pressable>
  )
}

function SelectableLink({ to, onPress, text, external }) {
  const [hovered, setHovered] = useState(false)

  return (
    <Pressable
      onPress={() => Linking.openURL(to)}
      onHoverIn={() => setHovered(true)}
      onHoverOut={() => setHovered(false)}
      style={({ pressed }) => (pressed ? { opacity: 0.8 } : undefined)}
    >
      <Link to={to}>
        <View style={[styles.pill, hovered && styles.pillHovered]}>
          <Text style={styles.pillText}>{text}</Text>
          {external ? <Feather name="arrow-up-right" size={12} color="#8a90a0" /> : null}
        </View>
      </Link>
    </Pressable>
  )
}
function HomePage({ navigation }) {
  const [visible, setVisible] = useState(false)
  const { width, height } = useWindowDimensions()

  const getTitleFontSize = () => (width >= 500 ? 90 : width < 375 ? 56 : 64)
  const getDescriptionFontSize = () => (width >= 500 ? 16 : 14)

  return (
    <View style={styles.container}>
      <HelpModal visible={visible} setVisible={setVisible} />
      <View style={styles.content}>
        <Text style={[styles.lockup, { fontSize: getTitleFontSize() }]}>
          billing
          <Text style={styles.lockupBh}>.bh</Text>
        </Text>
        <Text style={[styles.subhead, { fontSize: getDescriptionFontSize() }]}>is owned by Consult Me</Text>

        <View style={styles.pills}>
          <Selectable onPress={() => setVisible(true)} text={"What is this?"} />
          <SelectableLink to={"https://www.consultmebh.com"} onPress={() => Linking.openURL("https://www.consultmebh.com", "_blank")} text={"Consult Me"} external />
          <SelectableLink to={"/payment-agreement.pdf"} onPress={() => Linking.openURL("/payment-agreement.pdf", "_blank")} text={"Legal"} external />
        </View>
      </View>
    </View>
  )
}

function StackNavigator() {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name="Home" component={HomePage} options={{ title: "billing.bh" }} />
      <Stack.Screen name="Invoice" component={Invoice} options={{ title: "Invoice" }} />
    </Stack.Navigator>
  )
}

export default function App() {
  useFonts({
    PoppinsBold: require('./assets/fonts/Poppins-Bold.ttf'),
    PoppinsSemiBold: require('./assets/fonts/Poppins-SemiBold.ttf'),
    PoppinsMedium: require('./assets/fonts/Poppins-Medium.ttf'),
    PoppinsRegular: require('./assets/fonts/Poppins-Regular.ttf')
  })

  const config = {
    screens: {
      Main: {
        screens: {
          Home: '/',
          Invoice: {
            path: '/:invoiceLink'
          }
        }
      }
    }
  }

  const linking = {
    config
  }

  return (
    <ErrorBoundary>
      <NavigationContainer linking={linking}>
        <Stack.Navigator screenOptions={{ headerShown: false }}>
          <Stack.Screen name="Main" component={StackNavigator} />
        </Stack.Navigator>
      </NavigationContainer>
    </ErrorBoundary>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f6f8',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    width: '100%',
    maxWidth: 560,
    paddingHorizontal: 20,
    alignItems: 'center',
  },
  lockup: {
    fontFamily: 'PoppinsBold',
    color: 'rgb(255, 8, 46)',
    textAlign: 'center',
  },
  lockupBh: {
    color: 'black',
  },
  subhead: {
    fontFamily: 'PoppinsRegular',
    color: '#6b7280',
    textAlign: 'center',
    marginTop: 12,
  },
  pills: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 10,
    marginTop: 28,
  },
  pill: {
    paddingHorizontal: 18,
    paddingVertical: 10,
    borderRadius: 100,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    borderWidth: 1,
    borderColor: '#e6e8ec',
    backgroundColor: '#ffffff',
  },
  pillHovered: {
    backgroundColor: '#f1f3f5',
    borderColor: '#dadde2',
  },
  pillText: {
    fontFamily: 'PoppinsMedium',
    fontSize: 14,
    color: '#1f2430',
    userSelect: 'none',
  },
});
